import React, { Component } from 'react'
import { render } from 'react-dom';
import axios from 'axios'
import ServerInfo from '../../server.json'
import '../../App.css';

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
  let valid = true;
  Object.values(errors).forEach(
    (val) => val.length > 0 && (valid = false)
  );
  return valid;
}


class Registration extends Component {
    constructor(props) {
        super(props)

        this.state = {
            firstName: '',
            lastName: '',
            ic: '',
            value: 'State',
            state: '',
            email: '',
            password: '',
            // password_confirmation: '',
            isIframeOpen: false,
            epubIframeLink: 'epub_content/epubfile',
            ipAddress: ServerInfo.ipAddress,
            error:'',
            serverAddress: ServerInfo.serverAddress,
            errors: {
                firstName: '',
                lastName: '',
                ic: '',
                value: '',
                email: '',
                password: '',
                // password_confirmation: '',
              }
            };
            this._handleChange = this._handleChange.bind(this);
            this._handleSubmit = this._handleSubmit.bind(this);
          }

    // changeHandler = e => {
    //     this.setState({ [e.target.name]: e.target.value })
    // }

    _handleChange(event) {
      this.setState({value: event.target.value});
    }
  
    _handleSubmit(event) {
      event.preventDefault();
    }

    handleChange = (event) => {
        // event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;
        var re = /^\d{12,12}$/
    
        switch (name) {
            case 'firstName':
            errors.firstName = 
              value.length < 1
                ? 'First name is empty'
                : '';
            break;
            case 'lastName': 
            errors.lastName = 
              value.length < 1
                ? 'Last name is empty'
                : '';
            break;
            case 'ic': 
            errors.ic = 
              re.test(value)
                ? ''
                : 'IC is not valid!';
            break;
            // case 'state': 
            // errors.state = 
            //   value == 'State'
            //     ? 'State is not selected!'
            //     : '';
            // break;
          case 'email': 
            errors.email = 
              validEmailRegex.test(value)
                ? ''
                : 'Email is not valid!';
            break;
          case 'password': 
            errors.password = 
              value.length < 8
                ? 'Password must be 8 characters long!'
                : '';
            break;
            // case 'password_confirmation': 
            // errors.password_confirmation = 
            //   value.length < 8
            //     ? 'Password is not similar!'
            //     : '';
            // break;
          default:
            break;
        }
    
        this.setState({errors, [name]: value});
      }

      handleSubmit = (event) => {

        this.state.state = this.state.value
        // event.preventDefault();
        var status = false;
        if(validateForm(this.state.errors)) {
          console.info('Valid Form')
          if(this.state.firstName!="" && this.state.lastName!="" && this.state.ic!="" && this.state.state!="State" && this.state.email!="" && this.state.password!=""){
              this.state.error = ''
            status = true;
          }
          else{
            //   console.error('Invalid Form')
            this.state.error = 'Please complete the form'
            }
        //   console.log('status: '+JSON.stringify(this.state)+' : '+status+' : '+this.state.firstName);
          if(status==true){
            // this.state.error = ''

            this.submit();
          }
        }else{
          console.error('Invalid Form')
        // this.state.error = 'Please complete the form'
        }
      }
      
    componentDidMount() {
        this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
      }
      componentWillUnmount() {
        clearInterval(this.interval);
      }

    submit(){
        if (this.state.firstName != "" && this.state.lastName != "" && this.state.ic != "" && this.state.state!="State" && this.state.email != "" && this.state.password != "")
        {
            // e.preventDefault()
            console.log(this.state)
            
            var self = this
            var bodyFormData = new FormData();
            bodyFormData.append("firstName", this.state.firstName);
            bodyFormData.append("lastName", this.state.lastName);
            bodyFormData.append("identificationNumber", this.state.ic);
            bodyFormData.append("state", this.state.state);
            bodyFormData.append("email", this.state.email);
            bodyFormData.append("password", this.state.password);
            //bodyFormData.append("password", this.state.password);
            bodyFormData.append("loginVia", "direct");

            axios({
                method: 'post',
                url: this.state.serverAddress+'/user/addNewUser',
                // url: 'http://localhost:8080/user/addNewUser',
                data: {
                    "identificationNumber": this.state.ic,
                    "email": this.state.email,
                    "password": this.state.password,
                    "loginVia": "direct",
                    "firstName": this.state.firstName,
                    "lastName": this.state.lastName,
                    "school": null ,
                    "gender": null,
                    "level": null,
                    "role": "Pelajar",
                    "state": this.state.state,
                },
                config: {headers: {
                    "Content-Type": "multipart/form-data"}
                    }
            })
            .then(response => {
                console.log(response)
                // console.log("PASS")
                if(response.data.status == "1") // success
                {
                    this.props.closePopup()

                    alert('You have successfully registered!')
                }
            })
            .catch(error => {
                // console.log("ERROR")
                console.log(error)
            })
        }
    }

    handleKeyPress = (event) => {
      if(event.key === 'Enter'){
          this.handleSubmit()
      //   console.log('enter press here! ')
      }
    }

    renderError()
    {
        return(
        <span>{this.state.error}</span>
        )
    }

    render() {
        const { firstName, lastName, ic, state, email, password, errors } = this.state
        return (
            // <div>
            // <HeaderBar history={this.props.history}></HeaderBar>
            <div className='popup'>
                <div className='popup\_inner'>
                    <div style={styles.loginPanel} >
                        <div style={styles.panelHead} >
                            <img src='/images/Logo_AseanRead.png' style={styles.panelLogo} />
                        </div>
                        <button className="x" onClick={this.props.closePopup}>
                        x
                        </button>
                        <div style={styles.heading1}>
                            <div style={{margin:'5px'}}>
                                <input type="text" name="firstName" placeholder="First name" style={styles.inputText} value={firstName} onKeyPress={this.handleKeyPress} onChange={this.handleChange} noValidate />
                                <div/>{errors.firstName.length > 0 &&
                                <span className='error' style={{color: 'red'}}>{errors.firstName}</span>}
                            </div>
                            <div style={{margin:'5px'}}>
                                <input type="text" name="lastName" placeholder="Last name" style={styles.inputText} value={lastName} onKeyPress={this.handleKeyPress} onChange={this.handleChange} noValidate />
                                <div/>{errors.lastName.length > 0 &&
                                <span className='error' style={{color: 'red'}}>{errors.lastName}</span>}
                            </div>
                            <div style={{margin:'5px'}}>
                                <input type="text" name="ic" placeholder="Identification Number" style={styles.inputText} value={ic} onKeyPress={this.handleKeyPress} onChange={this.handleChange} noValidate />
                                <div/>{errors.ic.length > 0 &&
                                <span className='error' style={{color: 'red'}}>{errors.ic}</span>}
                            </div>
                            <div style={{margin:'5px'}}>
                              <select name="state" value={this.state.value} onChange={this._handleChange} style={styles.stateSelect}>
                                <option value="State">--Select State--</option>
                                <option value="Melaka">Melaka</option>
                                <option value="Kedah">Kedah</option>
                              </select>
                              
                            </div>
                            <div style={{margin:'5px'}}>
                                <input type="email" name="email" placeholder="Email" style={styles.inputText} value={email} onKeyPress={this.handleKeyPress} onChange={this.handleChange} noValidate />
                                <div/>
                                {errors.email.length > 0 &&
                                <span className='error' style={{color: 'red'}}>{errors.email}</span>}
                            </div>
                            <div style={{margin:'5px'}}>
                                <input type="password" name="password" placeholder="Password" style={styles.inputText} value={password} onKeyPress={this.handleKeyPress} onChange={this.handleChange} noValidate />
                                <div/>
                                {errors.password.length > 0 && 
                                <span className='error' style={{color: 'red'}}>{errors.password}</span>}
                            </div>
                            {/* <div>
                                <input type="password" name="password_confirmation" placeholder="Confirm password" style={styles.inputText} value={password_confirmation} onChange={this.handleChange} noValidate />
                                <div/>
                                {errors.password_confirmation.length > 0 && 
                                <span className='error'>{errors.password_confirmation}</span>}
                            </div> */}
                            <div style={{padding:"5px"}}>
                                <p style={{margin:'0px', color:'red'}}>{this.renderError()}</p>
                                <p style={{fontSize:"12px"}}>By clicking "Submit", you agree to AseanRead <a href='/termscondition' style={{cursor:"pointer", color:"#1e7b85", textDecoration:"underline"}}>Terms & Conditions</a></p>
                                <button style={styles.button} onClick={() => this.handleSubmit()}>Submit</button>
                                {/* <div style={{padding:"5px"}}/>
                                <button style={styles.closeBtn} onClick={this.props.closePopup}>Cancel</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            // {/* <BottomBar history={this.props.history}></BottomBar>
            // </div> */}
        )
    }
}

const styles = {
  inputText: {
    width: "240px",
    // size:"50",
    // textAlign: "center",
    // margin : "1vmin",
    padding: "12px",
    // borderRadius: "1vmin"
    // border: "none",
    // backgroundColor:"#f9f9f9"
},
    closeBtn: {
        cursor: 'pointer',
        backgroundColor: "#f47141", /* Green */
        border: "none",
        color: "white",
        // margin : "1vmin",
        // marginTop:"2vmin",
        padding: "5px",
        // textAlign: "center",
        // textDecoration: "none",
        // display: "inline-block",
        fontSize: "14px",
        width: "100px",
        height: "40px",
        borderRadius: "4px"
    },
    button: {
        cursor: 'pointer',
        backgroundColor: "#1e7b85", /* Green */
        border: "none",
        color: "white",
        // margin : "1vmin",
        // marginTop:"2vmin",
        padding: "5px",
        // textAlign: "center",
        // textDecoration: "none",
        // display: "inline-block",
        fontSize: "14px",
        width: "100px",
        height: "40px",
        borderRadius: "4px"
    },
    heading1: {
        // backgroundColor: "#527AAE",
        // padding: "1vmin",
        textAlign: "center",
        fontSize: "14px",
        color: "black",
        padding: "10px"
        // fontFamily: 'Myriad Pro Regular'
    },
    loginPanel: {
      width: "310px",
        minHeight: "350px",
        backgroundColor: "white",
        border: "solid",
        color: "#1e7b85",
        margin: "0",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
    panelHead: {
        backgroundColor: "#1e7b85",
        textAlign: 'center'
    },
    panelLogo: {
        height: '50px',
    },

    stateSelect: {
      width: "268px",
      padding: "12px",
    }
}

export default Registration
